import React, {useState, useEffect} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiDownload, FiX} = FiIcons;

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const {outcome} = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
      setShowInstallBanner(false);
    }
  };

  const handleDismiss = () => {
    setShowInstallBanner(false);
  };

  return (
    <AnimatePresence>
      {showInstallBanner && (
        <motion.div
          initial={{opacity: 0, y: -50}}
          animate={{opacity: 1, y: 0}}
          exit={{opacity: 0, y: -50}}
          className="bg-gradient-to-r from-primary-blue to-primary-pink text-white rounded-lg p-4 mb-6 shadow-lg"
        >
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center space-x-3">
              <SafeIcon icon={FiDownload} className="w-6 h-6" />
              <div>
                <h3 className="font-semibold">Instalar InnovaPrompt</h3>
                <p className="text-sm opacity-90">Accede sin conexión y desde tu pantalla de inicio</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <motion.button
                onClick={handleInstall}
                className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg font-medium transition-colors"
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
              >
                Instalar
              </motion.button>
              <motion.button
                onClick={handleDismiss}
                className="p-2 hover:bg-white/20 rounded-lg transition-colors"
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
                aria-label="Cerrar banner de instalación"
              >
                <SafeIcon icon={FiX} className="w-5 h-5" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstallPWA;